<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="组织单位"
                  :rules="rules.required"
                  v-model="item.organizer"
                />
              </v-flex>

              <v-flex xs6>
                <v-menu
                  ref="examineDatePickerRef"
                  lazy
                  :close-on-content-click="false"
                  v-model="examineDateMenu"
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    label="结项时间"
                    v-model="item.examineDate"
                    :rules="rules.examineDate"
                    hint="格式YYYY-MM-DD, 如：2018-10-01"
                    persistent-hint
                  />

                  <v-date-picker
                    v-model="examineDate"
                    locale="zh-cn"
                    @change="nv => item.examineDate= nv"
                  />
                </v-menu>
              </v-flex>

              <v-flex xs6>
                <v-text-field
                  label="结项编号"
                  :rules="rules.number"
                  v-model="item.number"
                />
              </v-flex>

              <v-flex xs3>
                <v-select
                  label="项目状态"
                  item-text="name"
                  item-value="dbid"
                  :rules="rules.required"
                  v-model="item.projStatusId"
                  :items="projStatusItems"
                />
              </v-flex>

              <v-flex xs3>
                <v-select
                  label="结项类型"
                  item-text="name"
                  item-value="dbid"
                  :rules="rules.required"
                  v-model="item.conclTypeId"
                  :items="conclTypeItems"
                />
              </v-flex>

              <v-flex xs3>
                <v-select
                  label="结项结论"
                  item-text="name"
                  item-value="dbid"
                  :rules="rules.required"
                  v-model="item.conclLevelId"
                  :items="conclLevelItems"
                />
              </v-flex>

              <v-flex xs3>
                <v-select
                  label="成果水平"
                  item-text="name"
                  item-value="dbid"
                  v-model="item.achivLevelId"
                  :items="achivLevelItems"
                />
              </v-flex>

              <v-flex xs12>
                <v-textarea
                  label="专家组成员"
                  :rules="rules.textarea"
                  counter="1000"
                  v-model="item.experts"
                />
              </v-flex>

              <v-flex xs12>
                <v-textarea
                  label="备注"
                  :rules="rules.textarea"
                  counter="1000"
                  v-model="item.note"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>

      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

  import mixin from '@/mixin'

  const baseURI = '/api/proj/conclusion';
  const projStatusURI = '/api/proj/proj-status';
  const conclTypeURI = '/api/proj/concl-type';
  const conclLevelURI = '/api/proj/concl-level';
  const achivLevelURI = '/api/proj/achiv-level';

  export default {
    mixins: [mixin.edit(baseURI)],
    props: ['value', 'uri', "dbid", 'projectId', 'projectClient'],

    data() {
      return {
        formValid: false,

        item: {},
        freshItem: {
          "projectId": null,
          //"form": null,
          "organizer": null,
          "projStatusId": null,
          "examineDate": null,
          "number": null,
          "experts": null,
          "conclTypeId": null,
          "conclLevelId": null,
          "achivLevelId": null,
          "timestamp": null,
          "userId": null,
          "userName": null,
          "note": null
        },

        examineDateMenu: false,
        examineDate:null,

        projStatusItems: [],
        conclTypeItems: [],
        conclLevelItems: [],
        achivLevelItems: [],
        /**
         * 验证规则
         */
        rules: {
          number: [
            v => (!v || v.length < 20) || '最多填 20 字符。'
          ],

          textarea: [
            v => (!v || v.length < 1000) || '最多填 20 字符。'
          ],

          required: [
            v => (!!v) || '必填项。',
            v => (v && v.length < 1000) || '最多填 1000 字符。'
          ],
          examineDate:[
            v => !!v || "必填项。",
            v => window.xutil.regexpDate().test(v) || '日期格式错误'
          ]
        }
      }
    },

    watch: {
      projectClient() {
        this.item.organizer = this.projectClient;
      }
    },

    created() {
      this.freshItem.organizer = this.projectClient;

      this.axios.all([
        this.axios.get(projStatusURI),
        this.axios.get(conclTypeURI),
        this.axios.get(conclLevelURI),
        this.axios.get(achivLevelURI)
      ]).then(
        this.axios.spread(
          (rspProjStatus, rspConclType, rspConclLevel, rspAchivLeve) => {
            this.projStatusItems = rspProjStatus.data.items.filter(v => v.name !== '在研');
            this.conclTypeItems = rspConclType.data.items;
            this.conclLevelItems = rspConclLevel.data.items;
            this.achivLevelItems = rspAchivLeve.data.items;
          }
        )
      )
    },

    methods: {
      // mixin 加载数据后调用
      // afterGetData(data) {
      // },

      beforeSendData(data) {
        //console.log("in beforeSendData");
        data.projectId = this.projectId;
      }
    }
  }
</script>
